import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ReduxState } from '../../../store';
import { isValidLatLng } from '../../../util/geoUtil';
import IncomingMaterialsMapWrapper from './IncomingMaterialsMapWrapper';

const SELECTED_MARKER_ZOOM = 15;

interface IncomingMaterialsMapContainerOwnProps {
  center: { lat: number; lng: number };
  zoom: number;
  onCenterChanged?: (center: { lat: number; lng: number }) => void;
  onZoomChanged?: (zoom: number) => void;
}

interface IncomingMaterialsMapContainerReduxProps {
  selectedMarker: ReduxState['selectedMarker'];
}

type IncomingMaterialsMapContainerProps = IncomingMaterialsMapContainerOwnProps &
  IncomingMaterialsMapContainerReduxProps;

interface IncomingMaterialsMapContainerState {
  lat: number;
  lng: number;
  zoom: number;
}

export class IncomingMaterialsMapContainer extends Component<
  IncomingMaterialsMapContainerProps,
  IncomingMaterialsMapContainerState
> {
  constructor(props: IncomingMaterialsMapContainerProps) {
    super(props);
    this.state = {
      lat: props.center.lat,
      lng: props.center.lng,
      zoom: props.zoom,
    };
  }

  componentDidUpdate(prevProps: IncomingMaterialsMapContainerProps) {
    // Center on selected marker when it changes
    if (this.props.selectedMarker !== prevProps.selectedMarker && this.props.selectedMarker) {
      const marker = this.props.selectedMarker;
      const { lat, lng } = marker;
      if (lat !== undefined && lng !== undefined && isValidLatLng(lat, lng)) {
        this.setState({
          lat,
          lng,
          zoom: SELECTED_MARKER_ZOOM,
        });
      }
    }

    // Update center when parent changes it (e.g., region change)
    if (
      prevProps.center.lat !== this.props.center.lat ||
      prevProps.center.lng !== this.props.center.lng
    ) {
      this.setState({
        lat: this.props.center.lat,
        lng: this.props.center.lng,
      });
    }

    if (prevProps.zoom !== this.props.zoom) {
      this.setState({ zoom: this.props.zoom });
    }
  }

  handleZoomChange = (zoom: number) => {
    if (this.state.zoom !== zoom) {
      this.setState({ zoom });
      this.props.onZoomChanged?.(zoom);
    }
  };

  handleCenterChange = (center: { lat: number; lng: number }) => {
    if (this.state.lat !== center.lat || this.state.lng !== center.lng) {
      this.setState({ lat: center.lat, lng: center.lng });
      this.props.onCenterChanged?.(center);
    }
  };

  render() {
    const { lat, lng, zoom } = this.state;

    return (
      <IncomingMaterialsMapWrapper
        location={{ lat, lng }}
        handleZoomChange={this.handleZoomChange}
        currentZoom={zoom}
        handleCenterChange={this.handleCenterChange}
      />
    );
  }
}

function mapStateToProps(state: ReduxState) {
  return {
    selectedMarker: state.selectedMarker,
  };
}

export default connect(mapStateToProps)(IncomingMaterialsMapContainer);
